import React from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import RoomForm from './RoomForm'
import { getRoomById } from '../api/rooms'

export default function BailleursEdit(){
  const { id } = useParams()
  const navigate = useNavigate()
  const { state } = useLocation()
  const [data, setData] = React.useState(state?.room || null)
  const [loading, setLoading] = React.useState(!state?.room)

  React.useEffect(() => {
    if (state?.room) return
    setLoading(true)
    getRoomById(id)
      .then(setData)
      .catch((e)=>console.warn('GET room failed', e))
      .finally(()=>setLoading(false))
  }, [id, state])

  return (
    <section className="section">
      <div className="container mx-auto px-4 max-w-5xl">
        <h2 className="section-title">{data ? 'Modifier l’annonce' : 'Chargement…'}</h2>
        {!loading && <RoomForm mode="edit" initial={data} onDone={()=>navigate('/bailleurs')} />}
      </div>
    </section>
  )
}
